import { Checkbox, InputLabel, ListItemText, MenuItem } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  StyledProjectsDropDown,
  StyledSelect,
} from '../../styles/CustomersStyle/CustomerManagementStyle';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function ProjectsDropdown({
  title,
  allProjects,
  employeeData,
  setEmployeeData,
  license_uuid,
  itemData,
  width,
}) {
  const [selectedProjects, setSelectedProjects] = useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    setSelectedProjects(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );

    let tempSkills = [...(employeeData?.trainings || [])];

    const temp = tempSkills.find((s) => s.license_uuid === license_uuid);

    if (!temp) {
      tempSkills.push({
        license_uuid: license_uuid,
        license_number: '',
        create_date: '',
        projects: value.map((project) => project.uuid),
      });
    } else {
      tempSkills = tempSkills.filter((s) => s.license_uuid !== license_uuid);
      tempSkills.push({
        ...temp,
        projects: value.map((project) => project.uuid),
      });
    }

    setEmployeeData({ ...employeeData, trainings: tempSkills });
  };

  useEffect(() => {
    // Prefer the trainings array (new/create flow) which stores project uuids
    const trainings = Array.isArray(employeeData?.trainings)
      ? employeeData.trainings
      : [];

    const training = trainings.find((s) => s.license_uuid === license_uuid);

    if (
      training &&
      Array.isArray(training.projects) &&
      Array.isArray(allProjects)
    ) {
      // training.projects contains project uuids -> map to project objects
      const selected = training.projects
        .map((pUuid) => allProjects.find((p) => p.uuid === pUuid))
        .filter(Boolean);

      setSelectedProjects(selected);
      return;
    }

    // Fallback: legacy shape `employeeLicense` (edit flow)
    const employeeLicenses = Array.isArray(employeeData?.employeeLicense)
      ? employeeData.employeeLicense
      : [];

    const lic = employeeLicenses.find((s) => s.license?.uuid === license_uuid);

    if (!lic) {
      setSelectedProjects([]);
    } else {
      const a =
        lic?.LicenseEmployeeProjects?.filter((obj) => obj?.project?.uuid).map(
          (obj) => obj.project,
        ) || [];

      setSelectedProjects(a);
    }
  }, [employeeData, allProjects, license_uuid]);

  //   employeeData.trainings.find(
  // 	(training) => training.license.uuid === license_uuid,
  //   ).LicenseEmployeeProjects

  return (
    <StyledProjectsDropDown width={width}>
      <InputLabel id="demo-multiple-checkbox-label">{title}</InputLabel>
      <StyledSelect
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        multiple
        value={selectedProjects}
        onChange={handleChange}
        renderValue={(selected) =>
          selected.map((project) => project.name).join(', ')
        }
        MenuProps={MenuProps}
      >
        {allProjects &&
          allProjects.map((project) => (
            <MenuItem key={project.uuid} value={project}>
              <Checkbox
                checked={selectedProjects
                  .map((project) => project.name)
                  .includes(project.name)}
              />
              <ListItemText primary={project.name} />
            </MenuItem>
          ))}
      </StyledSelect>
    </StyledProjectsDropDown>
  );
}

export default ProjectsDropdown;
